<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2045_5308)">
<mask id="path-2-inside-1_2045_5308" fill="white">
<rect x="6" y="13" width="11" height="7" rx="1"/>
</mask>
<rect x="6" y="13" width="11" height="7" rx="1" stroke="currentColor" stroke-width="3.4" mask="url(#path-2-inside-1_2045_5308)"/>
<path d="M20.2592 16.5L26.9285 16.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
<path d="M23.5938 13.1653L23.5937 19.8347" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2045_5308">
<rect width="22" height="22" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>
